import React from 'react';

export default function Contact(props) {
  return <div className="portfolio-screen-section mdl-typography--text-center">
    <a name="contact"></a>
    <div className="mdl-grid">
      <div className="pb-4 mdl-cell--12-col mdl-typography--display-1-color-contrast">
        <h1>Contact</h1>
        <h2 className="mdl-calc-desc">Alessandro Maclaine</h2>
        <a style={{color: "#6100a0"}} href="mailto:almaclaine@gmail.com">almaclaine@gmail.com</a>
        <div />
        <a style={{ color: "#6100a0" }} href="https://docs.google.com/document/d/1tLd3vkuYR_zSMoNS5zC_TUnN9v8957_KXSrfQh9I254/edit?usp=sharing">Resume</a>
      </div>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/Pages/Contact/Contact.js